import { get } from 'lodash/fp';
import { createAction, lt, showErrorAlert, TimeoutError, TrackingConsents } from '@mews/framework';
import { TrackingConsent } from '@mews/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { loadSalesForce } from '@mews-commander/chat';
import { getCookieFirstToken } from '../app/reducers/configuration';
import { prefix } from './module';

const TRACKING_CONSENTS_READY = prefix('TRACKING_CONSENTS_READY');
export const UPDATE_CONSENTS = prefix('UPDATE_CONSENTS');
const trackingConsentsReady = () => createAction(TRACKING_CONSENTS_READY);

export const prepareTrackingConsents =
    (): CommanderThunkAction =>
    async (dispatch, getState, { loggerService, trackingConsentsService }) => {
        const cookieFirstToken = getCookieFirstToken();

        if (cookieFirstToken) {
            try {
                const { isAlreadyInitialized, processTime } =
                    await trackingConsentsService.initAndOpenBanner(cookieFirstToken);
                if (!isAlreadyInitialized) {
                    loggerService.log(
                        'tracking-consents-processed',
                        'Tracking consents has been successfully processed.',
                        { processTime }
                    );
                }
            } catch (error) {
                if (error instanceof TimeoutError) {
                    loggerService.log('tracking-consents-timeout', 'Tracking consents has timed out.', {
                        processTime: error.timeout,
                    });
                } else {
                    loggerService.log(
                        'tracking-consents-init-error',
                        'Tracking consents service could not be initialized.',
                        { message: get('message', error) }
                    );
                }
            }
        }

        dispatch(updateConsents(trackingConsentsService.getAllConsents()));
        dispatch(trackingConsentsReady());
    };

export const openPanel =
    (): CommanderThunkAction =>
    (dispatch, getState, { trackingConsentsService }) => {
        try {
            trackingConsentsService.openPanel();
        } catch (error) {
            showErrorAlert({ description: lt('CookieServiceNotAvailableErrorMessage') });
        }
    };

const prepareFunctionalServices =
    (): CommanderThunkAction =>
    (dispatch, getState, { loggerService, gainsightService }) => {
        dispatch(loadSalesForce());

        gainsightService.initialize().catch((error: Error) => {
            loggerService.log('gainsight-service-init-error', 'Gainsight service could not be initialized.', {
                message: get('message', error),
            });
        });
    };

const updateConsents =
    (consents: TrackingConsents): CommanderThunkAction =>
    (dispatch) => {
        dispatch(createAction(UPDATE_CONSENTS, consents));
        if (get(TrackingConsent.Functional, consents)) {
            dispatch(prepareFunctionalServices());
        }
    };

export const prepareServicesRequiringConsents =
    (): CommanderThunkAction =>
    (dispatch, getState, { trackingConsentsService }) => {
        trackingConsentsService.subscribeToConsents((consents: TrackingConsents) => {
            dispatch(updateConsents(consents));
        });
    };
